import _extends from "@babel/runtime/helpers/extends";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';
import styled from 'styled-components';
import PageWrapper from '../PageWrapper';
import calculatePageScale from '../../utils/calculatePageScale';

var PageList = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(PageList, _React$PureComponent);

  function PageList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      pages: {}
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.forceUpdate();
    });

    _defineProperty(_assertThisInitialized(_this), "handleWaypointEnter", function (page) {
      page && _this.props.onPageChange && _this.props.onPageChange(page._pageIndex + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "handleLoadSuccess", function (page) {
      var _extends2;

      _this.setState({
        pages: _extends({}, _this.state.pages, (_extends2 = {}, _extends2[page._pageIndex] = page, _extends2))
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderPage", function (_ref) {
      var index = _ref.index,
          key = _ref.key,
          style = _ref.style;
      var pages = _this.state.pages;
      return /*#__PURE__*/React.createElement(Waypoint, {
        topOffset: "50%",
        bottomOffset: "49%",
        onEnter: _this.handleWaypointEnter.bind(_assertThisInitialized(_this), pages[index]),
        key: key
      }, /*#__PURE__*/React.createElement(PageWrapper, _extends({}, _this.props, {
        style: style,
        scale: _this.calculateScale(pages[index]),
        pageNumber: index + 1,
        onLoadSuccess: _this.handleLoadSuccess
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "calculateScale", function (page) {
      var _this$props = _this.props,
          fitTo = _this$props.fitTo,
          globalScale = _this$props.scale,
          container = _this$props.container;

      if (!page || !container) {
        return globalScale;
      }

      window.container = container;
      var containerSize = {
        width: container.clientWidth,
        height: container.clientHeight
      };
      return globalScale * calculatePageScale(page, containerSize, fitTo);
    });

    return _this;
  }

  var _proto = PageList.prototype;

  _proto.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  _proto.render = function render() {
    var _this2 = this;

    var pageCount = this.props.pageCount;
    return /*#__PURE__*/React.createElement(PreviewPageList, {
      className: "preview-page-list"
    }, Array.from({
      length: pageCount
    }, function (value, index) {
      return _this2.renderPage({
        index: index,
        key: "page-" + index
      });
    }));
  };

  return PageList;
}(React.PureComponent);

_defineProperty(PageList, "propTypes", {
  /**
   * How the pages should fit in the view port
   */
  fitTo: PropTypes.oneOf(['page', 'width']),

  /**
   * The global scale value to be applied on top of individual page scale values
   */
  scale: PropTypes.number,

  /**
   * The number of pages to display
   */
  pageCount: PropTypes.number,

  /**
   * Method called when a user scrolls to a new page
   */
  onPageChange: PropTypes.func,

  /**
   * Reference to a DOM node that is the container for the page list. Used to calculate the scale values when
   * zooming a document.
   */
  container: PropTypes.any
});

_defineProperty(PageList, "defaultProps", {
  fitTo: 'page',
  scale: 1
});

export { PageList as default };
var PreviewPageList = /*#__PURE__*/styled.div.withConfig({
  displayName: "PageList__PreviewPageList",
  componentId: "sc-15h9ii1-0"
})(["font-size:0;.react-pdf__Page{margin-bottom:22px;display:inline-block;}"]);